<template>
    <v-container class="fill-height">
        <v-row class="pt-5 mt-5">
            <v-col class="pt-5 mt-5">
                <v-img src="@/styles/error/404.png" style="width: 500px; margin: 0 auto;"></v-img>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="d-flex justify-center text-center">
                <h3>{{ $store.getters.t('죄송합니다.') }}<br>{{ $store.getters.t('현재 찾을 수 없는 페이지를 요청하셨습니다.') }}</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="d-flex justify-center text-center">
                {{ $store.getters.t('존재하지 않는 주소를 입력하셨거나,') }}<br>{{ $store.getters.t('요청하신 페이지의 주소가 변경, 삭제 되어 찾을 수 없습니다.') }}
            </v-col>
        </v-row>

        <v-row>
            <v-col class="d-flex justify-center">
                <v-btn rounded large x-large dark elevation="0" @click="goBack">
                    {{ $store.getters.t('뒤로가기') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    methods: {
        goBack() {
            window.history.back();
        },
    },
};
</script>
